export const OpensNewWindow = ', opens in a new window';
